import React from "react"
import { SwiperSlide } from "swiper/react"

import SingleEntryCellData from "./SingleEntryCellData"
import { Color } from "../../../../constants/V2/color"

type SwiperSlideContentProps = {
  data: string[][]
  columnCount: number
  tableTheme: "light" | "dark"
  backgroundColor: Color.Black | Color.Charcoal | Color.White | Color.MintGreen
  titleRowIndices: React.MutableRefObject<number[]>
}

const SwiperSlideContent = ({
  data,
  columnCount,
  tableTheme,
  backgroundColor,
  titleRowIndices,
}: SwiperSlideContentProps) => {
  const tableColumns = []

  for (let colIndex = 0; colIndex < columnCount; colIndex++) {
    const columnHeading = data[0][colIndex] || ""
    tableColumns.push(
      <SwiperSlide
        key={`${columnHeading.replace(" ", "-")}-${colIndex}`}
        className="swiper-no-swiping"
      >
        {data.map(
          (_, rowIndex) =>
            rowIndex !== 0 && (
              <SingleEntryCellData
                key={`${columnHeading.replace(" ", "-")}-${rowIndex}-${colIndex}`}
                rowIndex={rowIndex}
                columnIndex={colIndex}
                data={data}
                columnCount={columnCount}
                tableTheme={tableTheme}
                backgroundColor={backgroundColor}
                titleRowIndices={titleRowIndices}
              />
            )
        )}
      </SwiperSlide>
    )
  }

  return tableColumns
}

export default SwiperSlideContent
